<template>
    <div class="main" v-if="isLoading || !!error || ((!currentFD || currentFD.status !== 'LIVE') && !volunteerData)">
        <base-spinner v-if="isLoading"></base-spinner>
        <!-- Hide the greeting hero during a LIVE FD — the team card carries the greeting then -->
        <div v-else-if="(!currentFD || currentFD.status != 'LIVE') && !volunteerData" class="block">
            <div class="fd-hero">
                <div class="fd-hero__row">
                    <span class="fd-hero__wave">👋</span>
                    <span class="fd-hero__hi">Hi, <b>{{ currentUser.name }}</b></span>
                </div>

                <div v-if="currentFD && currentFD.status != 'LIVE'" class="fd-hero__chips">
                    <span class="fd-chip">
                        <span class="fd-chip__label">Next distribution</span>
                        <span class="fd-chip__value">📅 {{ currentFD.date.toDate().toLocaleDateString('en-GB') }}</span>
                    </span>
                    <span class="fd-chip">
                        <span class="fd-chip__label">Sponsored by</span>
                        <span class="fd-chip__value">🤝 {{ currentFD.sponsor ? currentFD.sponsor : "Apex" }}</span>
                    </span>
                </div>

                <div v-if="!currentFD" class="fd-hero__pending">
                    🔒 Registration isn’t open yet — check back soon.
                </div>
            </div>
        </div>

        <div v-if="!!error" class="notification is-danger is-light">
            <p><b>An error has occurred! </b></p>
            <p>Please inform the Apex team asap.</p>
            <p>Error Code: {{ error }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            error: ""
        }
    },
    methods: {
        findNextFD() {
            this.error = null;
            this.isLoading = true;
            try {
                this.$store.dispatch('fd/findNextFD');
            } catch (error) {
                console.error(error);
                this.error = error.code;
            }
            this.isLoading = false;
        }
    },
    created() {
        this.findNextFD();
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        },
        currentUser() {
            return this.$store.getters['user/getCurrentUser'];
        },
        volunteerData() {
            return this.$store.getters['volunteer/getVolunteerData'];
        },
    },
    unmounted() {
        this.$store.dispatch('fd/unsubscribeNextFD')
    }
}
</script>

<style scoped>
.fd-hero {
    border-radius: 18px;
    padding: 1.25rem 1.5rem;
    color: #fff;
    background: linear-gradient(135deg, #3b82f6 0%, #6366f1 55%, #8b5cf6 100%);
    box-shadow: 0 12px 28px -12px rgba(99, 102, 241, 0.65);
    animation: fd-hero-in 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes fd-hero-in {
    from { opacity: 0; transform: translateY(14px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
}

.fd-hero__row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.25rem;
}

.fd-hero__wave {
    display: inline-block;
    transform-origin: 70% 70%;
    animation: fd-wave 2.6s ease-in-out infinite;
}

@keyframes fd-wave {
    0%, 55%, 100% { transform: rotate(0deg); }
    10%, 30%      { transform: rotate(14deg); }
    20%           { transform: rotate(-8deg); }
    40%           { transform: rotate(-4deg); }
}

.fd-hero__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 1rem;
}

.fd-chip {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    padding: 0.55rem 0.95rem;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
    line-height: 1.2;
}

.fd-chip__label {
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.85;
}

.fd-chip__value {
    font-size: 1rem;
    font-weight: 700;
}

.fd-hero__pending {
    margin-top: 0.9rem;
    font-size: 0.95rem;
    background: rgba(255, 255, 255, 0.18);
    padding: 0.6rem 0.9rem;
    border-radius: 12px;
}

@media (prefers-reduced-motion: reduce) {
    .fd-hero { animation: none; }
    .fd-hero__wave { animation: none; }
}
</style>